import type { ItemType, Maybe } from "@shared/graphql.types"

type PriceType = {
  members: number
  typical: number
  guest: number
}

export const getPriceByType = (item: Maybe<ItemType>): PriceType => {
  switch (item?.type) {
    case "product":
      return {
        members: item?.variant?.pricing?.members ?? 0,
        typical: item?.variant?.pricing?.typical ?? 0,
        guest: item?.variant?.pricing?.guest ?? 0,
      }

    case "membership":
    case "giftMembership": {
      return {
        members: item?.membership?.price ?? 0,
        typical: 0,
        guest: 0,
      }
    }

    default:
      return { members: 0, typical: 0, guest: 0 }
  }
}
